<div class="container guides">
  <div class="">
    <h2 class="title">Guides</h2>
    <a href="https://sipsignal.com/assets/downloads/guide.pdf" class="download-link btn" download
      >eFax Guide <img src="assets/img/icons/download.svg" alt=""
    /></a>
  </div>
  <img src="assets/img/resources/guides.svg" alt="Guides: Background" />
</div>
<!-- /.container guides -->
